import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Timestamp } from 'firebase/firestore';
import { Vital } from 'src/app/calvin-emr-shared/models/vitals.model';

import { SelectItem } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { Select } from 'primeng/select';
import { NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { FloatLabel } from 'primeng/floatlabel';

@Component({
  selector: 'app-vitals-form',
  templateUrl: './vitals-form.component.html',
  styleUrls: ['./vitals-form.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
    Select,
    NgIf,
    ButtonDirective,
    FloatLabel,
  ],
})
export class VitalsFormComponent implements OnInit {
  vitalsForm = this.fb.group({
    heartRate: [],
    oxySat: [],
    oxygen: [],
    oxygenInput: [],
    respirations: [],
    temperature: [],
    systolic: [],
    diastolic: [],
  });

  @Output() newVitalEvent = new EventEmitter<Vital>();

  // Dropdown options for oxygen levels
  oxygenOptions: SelectItem[] = [
    { label: 'Nasal Cannula', value: 'Nasal Cannula' },
    { label: 'Venturi Mask', value: 'Venturi Mask' },
    { label: 'Non-Rebreather', value: 'Non-Rebreather' },
  ];

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.vitalsForm.get('oxygen')?.valueChanges.subscribe((value) => {
      if (value === 'Nasal Cannula' || value === 'Venturi Mask') {
        this.vitalsForm.get('oxygenInput')?.setValidators(Validators.required);
      } else {
        this.vitalsForm.get('oxygenInput')?.clearValidators();
        this.vitalsForm.get('oxygenInput')?.setValue('');
      }
      this.vitalsForm.get('oxygenInput')?.updateValueAndValidity();
    });
  }

  addNewVital(): void {
    // We assume nothing from the vitals array can be truly deleted, so use
    //  array length as vitals ID
    const newVital = new Vital(
      Timestamp.now(),
      this.vitalsForm.value.heartRate,
      this.vitalsForm.value.oxySat,
      this.vitalsForm.value.oxygen,
      this.vitalsForm.value.oxygenInput,
      this.vitalsForm.value.respirations,
      this.vitalsForm.value.temperature,
      this.vitalsForm.value.systolic,
      this.vitalsForm.value.diastolic,
      false
    );

    this.vitalsForm.reset();

    // Emit the new vital to vitals-tab, which calls addVital(newVital)
    this.newVitalEvent.emit(newVital);
  }

  get heartRateFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.heartRate as UntypedFormControl;
  }

  get oxySatFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.oxySat as UntypedFormControl;
  }

  get oxygenFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.oxygen as UntypedFormControl;
  }

  get oxygenInputFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.oxygenInput as UntypedFormControl;
  }

  get respirationsFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.respirations as UntypedFormControl;
  }

  get temperatureFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.temperature as UntypedFormControl;
  }

  get systolicFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.systolic as UntypedFormControl;
  }

  get diastolicFormControl(): UntypedFormControl {
    return this.vitalsForm.controls.diastolic as UntypedFormControl;
  }
}
